import React from 'react';

import Forgot from '../../Components/Auth/Forgot';
import Header from '../../Components/Auth/Header';


export default function ForgotPage() {
  return (
    <div className="auth">
      <Header/>
      <Forgot/>
    </div>
  );
}
